import { useState } from 'react';
import { ValidationError } from 'yup';

import { parseErrors } from 'v3/utils/formatter';

export default function useValidation(schema, paramOptions = {}) {
  const { pathPrefix } = paramOptions;
 const [errors, setErrors] = useState({});

  async function validate(value, options = {}) {
    try {
      const { abortEarly = false, context = {} } = options;
      const valid = await schema.validate(value, { abortEarly, context });

      setErrors({});

      return [true, valid];
    } catch (ex) {
      if (ex instanceof ValidationError) {
        const parsedErrors = parseErrors(ex.inner, { prefix: pathPrefix });
        setErrors(parsedErrors);
        return [false, undefined, parsedErrors];
      }
      return [false];
    }
  }

  async function validateAt(path, value, options = {}) {
    try {
      const { abortEarly = false, context = {} } = options;
      const valid = await schema.validateAt(path, value, {
        abortEarly,
        context,
      });

      setErrors({});

      return [true, valid];
    } catch (ex) {
      if (ex instanceof ValidationError) {
        const parsedErrors = parseErrors(ex.inner, { prefix: pathPrefix });
        setErrors(parsedErrors);
        return [false, undefined, parsedErrors];
      }
      return [false];
    }
  }

  return [errors, { validate, validateAt, setErrors }];
}
